# This would contain all the view logic for Step two to display the dropdown values with the filtered values
#
SupportProgressBarView = require('../progress_bar_view')
SupportStepActionsView = require('../step_actions_view')
SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view')
SupportErrorHelper = require('../../helpers/error')
SharedSpinnerView = require('../../../../shared/frontend/views/spinner_view')
SupportUtilsHelper = require('../../helpers/utils')
SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw')
Backbone = require 'backbone'
Backbone.$ = $
SupportStepTwoActionsTemplate = require('../../../step_two_actions.html.mustache')
SupportCategoryDropdownTemplate = require('../../../category_dropdown.html.mustache')
SupportSubCategoryDropdownTemplate = require('../../../sub_category_dropdown.html.mustache')

class StepTwoBaseView extends Backbone.View
  className: 'step-two'

  events:
    'general-message .inbenta-content': 'enableTicketDirectionButton'
    'help-text .inbenta-content': 'enableResolvedButton'
    'no-answer .inbenta-content': 'enableTicketDirectionButton'
    'change .category' : 'setCategoryToWindow'
    'change .sub-category': 'subCategoryChangeCallback'
    'click .view_fine_print': 'renderFinePrint'
    'click #continueToTicket': 'disableAllButton'
    "click #orderNotListed" : "disableAllButton"
    'click #merchant_link': 'renderPickOrder'

  initialize: (options)->
    @options = options || {}
    @I18nScope = 'modules.support'
    if Groupon.Support.MAXINDEX is 2
      @id = 1
    else
      @id = 2
    @categoryTemplate = SupportCategoryDropdownTemplate
    @subCategoryTemplate = SupportSubCategoryDropdownTemplate
    @tagLine = Groupon.Support.Tagline
    @dropDownModel = @options.dropDownModel
    @errorView = new SharedAjaxErrorView()
    @spinnerView = new SharedSpinnerView()
    @flexibleContactChannelModel = Groupon.Support.FlexibleContactChannelModel

  hideComponents: ->
    window.hideFooterLinks()
    if $("#intl_footer").length > 0
      $("#intl_footer").hide()
    SupportUtilsHelper.hideFloatingBoldChat()
    SharedWidgetLayoutView.hideWidgets()

  renderProgressBar: (contentWrapper)->
    progressBar = new SupportProgressBarView
    progressBar.render()
    contentWrapper.append(progressBar.el)

  renderOrderInfo: (contentWrapper)->
    if Groupon.Support.currentOrder && Groupon.Support.currentOrder != null
      order = Groupon.Support.currentOrder
      merchant = getDealMerchantName()
      contentWrapper.append("<h6 class='cb'><span id='tellUs'>#{I18n.t('js.modules.support.tellusaboutorder')}</span> <span id='merchant_link' data-bhw='merchant_link'><a class='deal-title'>#{merchant}</a>.</span></h6>")
    else
      contentWrapper.append("<h6 class='cb'><span id='tellUs'>#{I18n.t('js.modules.support.tellusaboutproblem')}</span></h6>")

  renderLiveChat:(childViewElem) ->
    liveChatmode = Groupon.Support.LiveChatModel.getDefaultStepTwoLiveChatMode()
    if Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()
      Groupon.Support.LiveChatView.setLiveChat(liveChatmode, Groupon.Support.LiveChatModel.getDefaultLiveChatType())
      Groupon.Support.LiveChatView.renderView(childViewElem, {})
      SupportUtilsHelper.showFloatingBoldChat()

  handleAjaxErrors : () ->
    @errorView.render({ container: @$el})

  filterDropdowns: (dropdowns, allTags) ->
    _.filter dropdowns, (item) =>
      return true unless item.tagLines?
      _.some item.tagLines, (tl) =>
        filterTags = tl.split ";"
        commonTags = _.intersection allTags, filterTags
        commonTags.length == filterTags.length

  getCategoryList:() ->
    dropdowns = @getDropdowns()
    if window.evaluate(experiments?.filterDropdowns) && @tagLine?
      allTags = @tagLine.split ","
      dropdowns = @filterDropdowns(dropdowns, allTags)
    _.sortBy dropdowns, (category) ->
      parseInt category.weight

  getSubCategoryList: () ->
    dropdowns = @getDropdowns()
    category = _.find dropdowns, (item) -> item.id == Groupon.Support.ContentModel.getCategory().id
    subCategories = category.subCategories
    if window.evaluate(experiments?.filterDropdowns) && @tagLine?
      allTags = @tagLine.split ","
      subCategories = @filterDropdowns(subCategories, allTags)
    _.sortBy subCategories, (s) ->
      parseInt s.weight

  getDropdowns : () ->
    @dropDownModel.attributes

  renderStepTwoActions: () ->
    stepActions = new SupportStepActionsView
      template: SupportStepTwoActionsTemplate
    stepActions.render()
    @$el.append(stepActions.el)
    if Groupon.Support.MAXINDEX == 2
      @$('.back').hide()

  hideContactUsButton: ->
    @$('.contact-us').hide()

  disableAllButton: ->
    @$('.issue-check').hide()
    @$('.direct-ticket').hide()
    @$('.refund-my-request').hide()

  sendTrackyCallForHelpContentBeingShown: (isHelpContentProper) ->
    data =
      categoryId: @getSubCategoryId()
      subCategoryId: @getSubCategoryId()
      tagline: Groupon.Support.Tagline
      country: window.country.name
      contentId: Groupon.Support.ContentModel.getContentId()
    if isHelpContentProper
      TrackingHub.add("help-content-shown", {helpContentShown: data})
    else
      TrackingHub.add("help-content-not-shown", {helpContentNotShown: data})

  helpContentLoadError: () ->
    @spinnerView.hide()
    category_id = @getCategoryId()
    sub_category_id = @getSubCategoryId()
    @$('.inbenta-content').attr("data-bhw", "hw__#{country.name}__#{category_id}__#{sub_category_id}__no-content-shown")
    @$('.inbenta-content').html(I18n.t("js.modules.support.default_help_text"))

  getCategoryId : () ->
    contentCategory = Groupon.Support.ContentModel.getCategory()
    category_id = if contentCategory?.id? then contentCategory.id else null

  getSubCategoryId : () ->
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory()
    sub_category_id = if contentSubCategory?.id? then contentSubCategory.id else null

  subCategoryChangeCallback: ()=>
    @setSubCategoryToWindow()
    @setFlexibleContactChannels()

  clearElement: (elem) ->
    @$(elem).empty()

  close: ->
    # Write close logic here

  renderFinePrint: ->
    SupportUtilsHelper.renderFinePrint()

  renderPickOrder: ->
    window.selectOrderFromMygroupons = false
    propagateEventBeforeReplacingElements( -> Backbone.history.navigate('#pick-order', {trigger: true}))

  shouldFetchFlexibleContactChannels: ()->
    @isFlexibleContactChannelsEnabled() and not @flexibleContactChannelModel.hasContactChannels()

  isFlexibleContactChannelsEnabled: () ->
    window.evaluate(window.experiments.showFlexibleContactChannels)

  areIdsSame: (id1, id2) ->
    if id1? && id2?
      id1 = id1.toLowerCase()
      id2 = id2.toLowerCase()
      (id1.indexOf(id2) > -1) or (id2.indexOf(id1) > -1)
    else
      return false

  findFlexibleContactChanel: (categoryId, subcategoryId) ->
    contactChannels = @flexibleContactChannelModel.getContactChannels()
    if contactChannels? && categoryId? && subcategoryId?
      categoryList = _.keys(contactChannels)
      matchedCategory = _.find(categoryList, (source) =>
        @areIdsSame(source, categoryId)
      )
      if matchedCategory?
        contactChannelsForSelectedCategory = $.extend true, {}, contactChannels[matchedCategory].subCategories
        return _.find(contactChannelsForSelectedCategory, (channel) =>
          @areIdsSame(channel?.id,  subcategoryId)
        )

  setFlexibleContactChannels: () ->
    if @isFlexibleContactChannelsEnabled()
      categoryId = Groupon.Support.ContentModel.getCategory()?.id
      subcategoryId = Groupon.Support.ContentModel.getSubCategory()?.id
      contactChannelsForDropdown = @findFlexibleContactChanel(categoryId, subcategoryId)
      unless contactChannelsForDropdown?
        if @flexibleContactChannelModel.getContactChannels()?
          TrackingHub.add("flexible-contactChannel-missing", SupportErrorHelper.constructFlexibleContactChannelMissingMessage())
        return @flexibleContactChannelModel.invalidateFlexibleContactChannels()
      delete contactChannelsForDropdown.id
      delete contactChannelsForDropdown.text

      _.each contactChannelsForDropdown, (value, key) =>
        unless value? then delete contactChannelsForDropdown[key]

      @flexibleContactChannelModel.setFlexibleContactChannels(contactChannelsForDropdown)

module.exports = StepTwoBaseView
